import * as types from '../mutation-types'

import Vue from 'vue'
import axios from 'axios'
import router from '@/router'

const TOKEN_NAME = 'token'

// initial state
const state = {
  token: window.localStorage.getItem(TOKEN_NAME),
  username: window.localStorage.getItem('username')
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
let mutations = {}

mutations[types.SET_TOKEN] = function (state, r) {
  state.token = r.token
  state.username = r.username
  window.localStorage.setItem(TOKEN_NAME, r.token)
  window.localStorage.setItem('username', r.username)
}

mutations[types.LOGOUT] = function (state) {
  state.token = null
  state.username = null
  window.localStorage.removeItem(TOKEN_NAME)
  window.localStorage.removeItem('username')
  router.push({
    name: 'Login'
  })
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js